module.exports = __webpack_public_path__ + "img/pago-exitoso.1775640a.png";